<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage company branding</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="organizationId" class="container">
            <img v-if="logoUrl" :src="logoUrl" style="max-width: 200px;" /><br /><br />

            <FileUploader :ttl="null" :skipConfirmation="false" :hideProgress="true" @selected="logoFile=$event" @uploaded="handleLogoUploaded" accept="image/png,image/gif,image/jpeg,image/svg+xml">
                <button type="button" class="btn btn-secondary">Change logo</button>
                <template v-slot:file>
                    &nbsp;
                </template>
            </FileUploader>
            <br />

            <button v-if="logoBlobId" @click="handleRemoveLogo" type="button" class="btn btn-secondary">Remove logo</button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { useOrganizationUnitId } from '@common/composables'
    import { useManageBrandingPage } from '@Organizations/OrganizationUnits/pages-core'
    import FileUploader from '@Blobs/Components/FileUploader.vue'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import axios from 'axios'

    const tid = useOrganizationUnitId()
    const logoFile = ref<File | null>(null)
    const logoBlobId = ref<string | null>(null)

    const {
        useBrandingQuery,
        useApplyBrandingCommand,
        useResetBrandingCommand
    } = useManageBrandingPage()

    const { modelBrandingQueryV1, runBrandingQueryV1 } = useBrandingQuery(tid)

    const organizationId = computed(() => modelBrandingQueryV1.value?.Id)
    const logoUrl = computed(() => logoFile.value ? URL.createObjectURL(logoFile.value) : modelBrandingQueryV1.value?.LogoUrl)

    const { invokeApplyBrandingCommandV1 } = useApplyBrandingCommand(organizationId, logoBlobId)
    const { invokeResetBrandingCommandV1 } = useResetBrandingCommand(organizationId)

    onMounted(() => {
        document.title = 'Manage branding'
        runBrandingQueryV1()
    })

    watch(modelBrandingQueryV1, () => logoBlobId.value = modelBrandingQueryV1.value?.LogoBlobId)

    function handleLogoUploaded(blobId: string) {
        logoBlobId.value = blobId
        invokeApplyBrandingCommandV1()        
    }

    async function handleRemoveLogo() {
        if (confirm('Do you really want to remove logo?')) {
            try {
                await axios.delete('/blobs/v2/delete/' + (logoBlobId.value || ''))
            } finally {
                invokeResetBrandingCommandV1()
                runBrandingQueryV1()
                logoFile.value = null
            }
        }
    }
</script>
